import { deleteCookieByName, deleteHostCookieByName, getCookieByName, setHostCookie } from './cookies'

export const ensureNfAbMasterCookie = (reloadGuardKey = 'nf_ab_reload_done') => {
  const cookieName = 'nf_ab'
  const cookieValue = 'master'

  if (getCookieByName(cookieName) === cookieValue) return false
  if (sessionStorage.getItem(reloadGuardKey) === '1') return false

  // Clear both domain and host-only versions, then set host-only for this subdomain.
  // This avoids a subdomain cookie overriding a parent-domain cookie.
  deleteCookieByName(cookieName)
  deleteHostCookieByName(cookieName)
  setHostCookie(cookieName, cookieValue, 30)

  // Give the browser a tick to persist the cookie before reloading.
  setTimeout(() => {
    // Re-apply in case something wrote a different value very early in page load.
    setHostCookie(cookieName, cookieValue, 30)
    if (getCookieByName(cookieName) !== cookieValue) return
    sessionStorage.setItem(reloadGuardKey, '1')
    window.location.reload()
  }, 50)

  return true
}
